module.exports = "/_next/static/images/1771e04c3a1ae16cede6e23c2b33de98-for-who-md.jpg";